import React, { createContext, useContext, useReducer } from 'react';

export const ACTIONS = {
  SET_SHOW_OVERLAY: 'SET_SHOW_OVERLAY',
  SET_SHOULD_SHOW_COMMENTS_LIST: 'SET_SHOULD_SHOW_COMMENTS_LIST',
  SET_SITE_PAGES_IDS: 'SET_SITE_PAGES_IDS',
};

const mainReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_SHOW_OVERLAY:
      return {
        ...state,
        showOverlay: action.payload,
      };
    case ACTIONS.SET_SHOULD_SHOW_COMMENTS_LIST:
      return {
        ...state,
        shouldShowCommentsList: action.payload,
      };
    case ACTIONS.SET_SITE_PAGES_IDS:
      return {
        ...state,
        pageIds: action.payload,
      };
    default:
      return state;
  }
};

const AppContext = createContext(null);
export function AppContextProvider(props) {
  const INITIAL_STATE = {
    ...props,
    showOverlay: false,
    shouldShowCommentsList: true,
    pageIds: [],
  };
  const [state, dispatch] = useReducer(mainReducer, INITIAL_STATE);
  const generateContext = () => {
    return {
      state,
      dispatch,
    };
  };
  return (
    <AppContext.Provider value={generateContext()}>
      {props.children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const appContext = useContext(AppContext);
  if (!appContext) {
    throw new Error(
      'useAppContext must be used within the AppContext.Provider',
    );
  }
  return appContext;
}
